export default "__VITE_ASSET__BY6S4SfE__"